import {React,useEffect, useState} from "react";
import Popup from "./Popup";
import Table1 from "./Table1";
import Button from "./Button";
import { useReducer } from "react";
import Confirm from "./Confirm"
import { reducer,initialState } from "../reducers/reducers";
import Dropdown from "./Dropdown";
import DropdownSearch from "./DropdownSearch";
import EditQuantity from "./EditQuantity";
import { useAuth } from "./AuthProvider";
import EditText from "./EditText";
import API_URLS from "../Urls";

const ViewBudget = ({data, onClose}) => {
    const [total,setTotal] = useState(0)
    const [discount, setDiscount] = useState(data.descuento)
    const [discountToSet, setDiscountToSet] = useState(0)
    const [discountEditable, setDiscountEditable] = useState(false)
    const [client,setClient] = useState()
    const [selectedItem,setSelectedItem] =useState({}) //selected 
    const [fetchedTypes,setFetchedTypes] = useState([]) //options for the first dropdown to add the item to the itemlist
    const [fetchedItems,setFetchedItems ] = useState([]) //options for the second dropdwon
    const [itemToDelete,setItemToDelete] = useState()
    const [objects,setObjects]=useState([]) //these are the items included in the budget
    const{ isAuthenticated, user} = useAuth();
    const [item_keys,setItem_keys] = useState([])
    const [state, dispatch] = useReducer(reducer, initialState);
    const [addItem, setAddItem] = useState(false)
    const [itemQ,setItemQ] = useState(0) //used to store the item were gonna edit the quantity of.
    const postData = (url, dataToSend, onSuccesful) => {
      console.log("Posting to URL:", url); // Check URL during each post
      console.log("Data to send:", dataToSend);

      fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dataToSend)
      })
      .then(response => {
          if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
          return response.json();
      })
      .then(data => {
          if (typeof onSuccesful === 'function') onSuccesful(data);
          console.log(data);
      })
      .catch(error => console.error('There was a problem with the fetch operation:', error));
  };
  const putData = (url, dataToSend, onSuccesful) => {
      console.log("Posting to URL:", url); // Check URL during each post
      console.log("Data to send:", dataToSend);

      fetch(url, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dataToSend)
      })
      .then(response => {
          if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
          return response.json();
      })
      .then(data => {
          if (typeof onSuccesful === 'function') onSuccesful(data);
          console.log(data);
      })
      .catch(error => console.error('There was a problem with the fetch operation:', error));
  };

useEffect(() => {
    setFetchedTypes([])
    setFetchedItems([])
    console.log(data.tipo)
    setSelectedItem((prev)=>({...prev,cantidad:1}))
    if (!selectedItem.object_type) return;

    switch (selectedItem.object_type) {
        case 'Accesorio':
            fetchData(API_URLS.ACCESORIES, (data) =>
                setFetchedTypes([...new Set(data.map(acc => acc.tipo))])
            );
            break;
        case 'Parte':
            fetchData(API_URLS.PARTS, (data) =>
                setFetchedTypes([...new Set(data.map(acc => acc.tipo))])
            );
            break;
        case 'Dron':
        case 'Drones':
            fetchData(API_URLS.DRONES, (d) =>
                setFetchedTypes([...new Set(d.filter(item => item.linea == data.tipo).map(acc => acc.serie))])
            );
            break;
 
        case 'Servicio':
            fetchData(API_URLS.SERVICES, (d) =>
                setFetchedItems([...new Set(d.filter(item => item.linea == data.tipo))])
            );
            setSelectedItem(prev=>({...prev,tipo:"N/A"}))
            break;
    }
}, [selectedItem.object_type]);
 
const renderAddItem = (object_type) => {
    
    switch (object_type) {
        case 'Accesorio':
            return(
              
            <div className="invisible-horizontal-container">
              
                    Tipo de {object_type.toLowerCase()}:
                    <DropdownSearch
                        
                        options={fetchedTypes}
                        returnSelectedKey={data=>setSelectedItem(prev=>({...prev,id:data}))}
                        keys={fetchedItems.map(item=>item.id)}
                        returnSelectedOption={(data) =>{
                            setSelectedItem((prev) => ({ ...prev, tipo: data }))
                            fetchData(API_URLS.ACCESORIES + "?tipo=" + data, (data) =>{setFetchedItems(data)})
                        }
                        }
                    />
                    Modelo:
                    <DropdownSearch 
                       
                        keys={fetchedItems.map(item=>item.id)} 
                        returnSelectedKey={data=>setSelectedItem(prev=>({...prev,id:data}))} 
                        returnSelectedOption={data=>setSelectedItem(prev=>({...prev,modelo:data,modelo:data, concepto: prev.tipo + " " + data}))} 
                        
                        options={fetchedItems.map((item)=>item.modelo)}/>
                </div>)
                break;
        case 'Parte':
            return (
                <div className="invisible-horizontal-container">
                    Tipo de {object_type.toLowerCase()}:
                    <DropdownSearch
                        
                        options={fetchedTypes}
                        returnSelectedOption={(data) =>{
                            setSelectedItem((prev) => ({ ...prev, tipo: data }))
                            fetchData(API_URLS.PARTS + "?tipo=" + data, (data) =>{setFetchedItems(data)})}
                        }
                    />
                    Modelo:
                    <DropdownSearch 
                        
                        keys={fetchedItems.map(item=>item.id)} 
                        returnSelectedOption={data=>setSelectedItem(prev=>({...prev,modelo:data, concepto: prev.tipo + " " + data}))} 
                        returnSelectedKey={data=>setSelectedItem(prev=>({...prev,id:data}))} 
                        
                        options={fetchedItems.map((item)=>item.modelo)}/>
                </div>
            );
            break;
        case 'Dron':
            return (
                <div className="invisible-horizontal-container">
                    Serie:
                    <DropdownSearch 
                        
                        returnSelectedOption={(data)=>{
                          setSelectedItem(prev=>({...prev,serie:data}))
                          fetchData(API_URLS.DRONES + "?serie=" + data, (data) =>{setFetchedItems(data)})
                      }
                      } 
                        options={fetchedTypes} />
                    Modelo:
                    <DropdownSearch 
                        
                        keys={fetchedItems.map(item=>item.id)} 
                        returnSelectedOption={data=>setSelectedItem(prev=>({...prev,modelo:data,concepto: prev.serie + " " + data}))} 
                        returnSelectedKey={data=>setSelectedItem(prev=>({...prev,id:data}))} 
                        options={fetchedItems.map((item)=>item.modelo)} 
                        />
                </div>
            );

        case 'Servicio':
            return (
                <div className="invisible-horizontal-container">
                    Concepto:
                    <DropdownSearch 
                        
                        returnSelectedKey={data=>setSelectedItem(prev=>({...prev,id:data}))} 
                        keys={fetchedItems.map(item=>item.id)} 
                        returnSelectedOption={data=>setSelectedItem(prev=>({...prev,nombre:data, concepto: data}))} 
                        options={fetchedItems.map((item)=>item.nombre)} 
                        />
                </div>
            );
        default:
            return null;
    }
};
    function downloadPDF(folio) {
        // Make the GET request to fetch the PDF file
        fetch(API_URLS.PRINT_FOLIO +'?folio=' + folio + '&username='+user.usuario, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/pdf', // Optional: Specify the content type
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.blob(); // Convert the response to a Blob
          })
          .then((blob) => {
            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([blob]));
            
            // Create a temporary link element
            const link = document.createElement('a');
            link.href = url;
      
            // Set the file name for the download
            link.setAttribute('download', folio + '.pdf');
      
            // Append the link to the body and trigger a click
            document.body.appendChild(link);
            link.click();
      
            // Clean up: remove the temporary link and revoke the URL
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error('Error while fetching the PDF:', error);
          });
      }
      const deleteItem =(url,onSuccesful)=>{
        console.log(url)
        fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }})
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        })
        .then(data => {
          console.log(data)
          if (typeof onSuccesful === 'function') onSuccesful(data) })// Update the state with fetched data})
        .catch(error => console.error('There was a problem with the fetch operation:', error));}
      const fetchData =(url,onSuccesful)=>{
        console.log(url)
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }})
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        })
        .then(data => {
          console.log(data)
          if (typeof onSuccesful === 'function') onSuccesful(data) })// Update the state with fetched data})
        .catch(error => console.error('There was a problem with the fetch operation:', error));}
    const fetchBudgetContent = () =>{
      fetchData(API_URLS.CLIENTS + "?id=" + data.idCliente,(data)=>setClient(data[0]))

      fetchData(API_URLS.BUDGETOBJECT + '?folio=' + data.folio, (baseData) => {
    const fetchPromises = baseData.map(item =>
      new Promise((resolve) => {
        let url = "";
        switch (item.tipo) {
          case 'Dron':
          case 'Dron Enterprise':
          case 'Dron Comercial':
            url = API_URLS.DRONES;
            break;
          case 'Parte':
            url = API_URLS.PARTS;
            break;
          case 'Accesorio':
          case 'Accesorios':
            url = API_URLS.ACCESORIES;
            break;
          case 'Servicio':
            url = API_URLS.SERVICES;
            break;
          default:
            console.warn(`Unknown tipo: ${item.tipo}, skipping`);
            return resolve(null); // skip this item
        }

        fetchData(url + '?id=' + item.item_id, (detailData) => {
          if (!detailData || detailData.length === 0) {
            console.warn(`No data found for objectid=${item.objectid}`);
            return resolve(null);
          }

          const { tipo: _, ...itemWithoutTipo } = item;
          resolve({
            ...detailData[0],
            ...itemWithoutTipo,
            objecttype: item.tipo // preserve original tipo separately
          });
        });
      })
    );
    
    Promise.all(fetchPromises)
      .then(enrichedObjects => {
        const validObjects = enrichedObjects.filter(item => item !== null);
        console.log(validObjects)
        setObjects(validObjects.map(item=>{
          switch(item.objecttype){
            case 'Accesorio':
            case 'Parte':
              return {...item,concepto: item.tipo + " " + item.modelo}
              break;
            case 'Dron':
            case 'Dron Enterprise':
            case 'Dron Comercial':
              return {...item,concepto: item.serie + " " + item.modelo}
              break;
            case 'Servicio':
              return {...item,concepto: item.nombre}
              break; 
          }
        }))
        setTotal(validObjects.reduce((sum, item) => sum + (item.precio || 0), 0));
      })
      .catch(error => {
        console.error('Error enriching object data:', error);
      });
  });
    }
    useEffect(()=>{
      console.log(data)
      fetchBudgetContent()
    },[])
  
    return (
      <Popup title={'Ver ' + data.folio} onClose={onClose}>
        <div className="invisible-horizontal-container">Cliente:  {client && (client.nombre || client.apellidos) && `${client.nombre ?? ''} ${client.apellidos ?? ''}`}</div>
        <div className="invisible-horizontal-container">Total: {total}</div>
        <div className="invisible-horizontal-container"> 
          { discountEditable ? (
            <div className="invisible-horizontal-container">{'Descuento (%)'}:
            <input
                  type="number"
                  min={1}
                  defaultValue={discount}
                  max={100}
                  // value={currentObject.cantidad || ''}
                  onChange={(data) => {
                    const value = data.target.value;
                    // Limitar a 3 caracteres y solo números
                    if (value.length <= 3 && /^\d*$/.test(value)) {
                      const numericValue = parseInt(value, 10);
                      // Asegurarse de que el valor esté dentro del rango permitido
                      if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 100) {
                        setDiscountToSet(numericValue)
                      } else if (value === '') {
                        setDiscountToSet(0)
                      }
                  }
                  }}
                />
            <Button text='📼' onClick={()=>{
              putData(API_URLS.BUDGETS,{...data, descuento: discountToSet},(d)=>{
                          if(d.success==true){
                            setDiscount( discountToSet)
                            setDiscountEditable(false)
                          } else {
                            alert('Hubo un problema al actualizar')
                            setDiscountEditable(false)
                          }
                        })
            }}></Button>
            </div>
          ):(
            <div className="invisible-horizontal-container">
              Descuento: {discount ?? 0}% 
              <Button onClick={()=>{setDiscountEditable(true)}} text='✏️'></Button>
            </div>
          )

          }
         


        </div>
        <div className="invisible-horizontal-container">Total con descuento: {((100-(discount ?? 0)) * total * 0.01)}</div>
        <div className="header1">Contenido</div>
        <Table1
          optdelete={true}
          onClickDelete={(item,rowIndex) => {
            
            setItemToDelete(objects[rowIndex].id)
            dispatch({ type: 'openConfirmMessage' }); // Show confirmation
          }}
          headers={['','Concepto', 'Precio Unidad', 'Cantidad', 'Precio total']}
          data={objects.map(item=>({objecttype:item.objecttype, concepto:item.concepto, price:item.precio, cantidad:item.cantidad, total_price: item.precio * item.cantidad }))}
        />
        { !selectedItem.object_type ? (
          <Button onClick={()=>setSelectedItem({object_type:'Servicio',cantidad:1})} color="#318acc" text="Agregar item"></Button>
        ):(<div className="invisible-horizontal-container"> <Dropdown returnSelectedOption={(data)=>setSelectedItem({...selectedItem,object_type:data})} options={['Servicio','Parte','Accesorio','Dron']}></Dropdown>
                    {renderAddItem(selectedItem.object_type)}
                    Cantidad:
                    <input
                        type="number"
                        min={1}
                        defaultValue={1}
                        max={100}
                        // value={currentObject.cantidad || ''}
                        onChange={(data) => {
                            const value = data.target.value;
                            // Limitar a 3 caracteres y solo números
                            if (value.length <= 3 && /^\d*$/.test(value)) {
                                const numericValue = parseInt(value, 10);

                                // Asegurarse de que el valor esté dentro del rango permitido
                                if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 100) {
                                    setSelectedItem((prev)=>({...prev,cantidad:numericValue}))
                                } else if (value === '') {
                                    setSelectedItem((prev)=>({...prev,cantidad:0}))
                                }}
                            }}
                    />
                    <Button text="Agregar item"  color="#318acc" onClick={()=>{console.log(selectedItem);postData(API_URLS.BUDGETOBJECT,{cantidad:selectedItem.cantidad,custom_object_name:"",tipo:selectedItem.object_type,cotizacion_folio:data.folio,item_id:selectedItem.id,},()=>{setSelectedItem({});fetchBudgetContent()})}}></Button></div>)

        }
        
          <Button
            text="Exportar"
            color="#7AACE3"
            onClick={() => {
              downloadPDF(data.folio);
            }}
          />
        
        {state.statusConfirmMessage && (
          <Confirm
            onDelete={() => {
              deleteItem(API_URLS.BUDGETOBJECT+"?id="+itemToDelete,()=>{dispatch({ type: 'closeConfirmMessage' })})
            }}
            onCancel={() => {
              dispatch({ type: 'closeConfirmMessage' });
            }}
          />
        )}
        {state.statusEditQuantity && (
          <EditQuantity item_id={itemQ} url={API_URLS.BUDGETOBJECT} onAccept={()=>{
            
          }}
          onCancel={()=>dispatch({ type: 'closeEditQuantity' })}></EditQuantity>
        )}
      </Popup>
    );
    }
    export default ViewBudget;